import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Menu } from '@material-ui/core'
import api from '../../services/api'
import toastError from '../../errors/toastError'
import { useStyles } from './style'

// Importação do componente padronizado
import EmojiOptions from '../EmojiOptions'
import { CirclePlus } from 'lucide-react'

const mostUsedEmojis = ['👍', '❤️', '😂', '🎉', '😮', '😢', '🙏']

const MessageReactionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const classes = useStyles()

  // Estado para controlar a visibilidade do seletor completo via EmojiOptions
  const [showEmoji, setShowEmoji] = useState(false)

  const closeMenu = () => {
    handleClose()
    setShowEmoji(false)
  }

  const handleReact = async emojiData => {
    // Normalização: aceita string (emojis rápidos) ou objeto (do Picker)
    const emoji = typeof emojiData === 'string' ? emojiData : emojiData.native

    handleClose()
    setShowEmoji(false)

    try {
      await api.post(`/messages/react/${message.id}`, {
        ticketId: message.ticketId,
        emoji
      })
    } catch (err) {
      toastError(err)
    }
  }

  return (
    <>
      <Menu
        elevation={0}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={menuOpen}
        onClose={closeMenu}
        className={classes.menu}
        anchorOrigin={{
          vertical: 'bottom', // Ancorar no topo do ícone
          horizontal: 'center' // Centralizado horizontalmente
        }}
        transformOrigin={{
          vertical: 'top', // O menu cresce para cima
          horizontal: 'center'
        }}
      >
        <div className={classes.flexContainer}>
          {/* Renderização dos emojis rápidos */}
          {mostUsedEmojis.map((emoji, index) => (
            <div
              className={classes.emojiButton}
              onClick={() => handleReact(emoji)}
              key={index}
            >
              {emoji}
            </div>
          ))}

          {/* Integração do EmojiOptions no botão de expansão (+) */}
          <div
            className={classes.emojiButtonMenu}
            onClick={e => e.stopPropagation()} // Impede que o clique feche o Menu precocemente
          >
            <EmojiOptions
              disabled={false}
              handleAddEmoji={handleReact}
              showEmoji={showEmoji}
              setShowEmoji={setShowEmoji}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
              >
                <CirclePlus size={24} />
              </div>
            </EmojiOptions>
          </div>
        </div>
      </Menu>
    </>
  )
}

MessageReactionsMenu.propTypes = {
  message: PropTypes.object.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.object
}

export default MessageReactionsMenu
